








































import { Component, Vue, Prop } from 'vue-property-decorator'
import JoinButton from '@/components/JoinButton.vue'
import Project from '../model/project'

@Component({
  components: {
  JoinButton,
  }
  })
export default class ProjectCard extends Vue {
  @Prop() private project!: Project;
  @Prop() private joinEnable!: boolean;
  @Prop() private onClickJoin!: Function;
  @Prop() private needLogin!: boolean;

  detailLink (): string {
    return `/projects/detail?project_id=${this.project.uid}`
  }
}
